<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div>
      <input
        type="number"
        :id="id"
        class="w-full ui-input-number"
        :class="[$attrs.class, { 'p-invalid': validation?.$error }]"
        :value="modelValueComputed"
        :disabled="disabled"
        :placeholder="placeholder"
        :min="min"
        :max="max"
        :aria-describedby="`${id}-help`"
        @input="$emit('update:modelValue', $event.target.valueAsNumber || 0)"
      />
      <span
        v-if="
          validation?.$error &&
          validation.required &&
          validation.required.$invalid
        "
        :id="`${id}-help`"
        class="p-error text-left mt-2"
      >
        {{ validation.required.$message.replace("Value", PropName) }}
      </span>
      <span
        v-if="
          validation?.$error && validation.integer && validation.integer.$invalid
        "
        :id="`${id}-help`"
        class="p-error text-left mt-2"
      >
        {{ validation.integer.$message.replace("Value", PropName) }}
      </span>
      <span
        v-if="
          validation?.$error &&
          validation.minValue &&
          validation.minValue.$invalid
        "
        :id="`${id}-help`"
        class="p-error text-left mt-2"
      >
        {{ validation.minValue.$message.replace("Value", PropName) }}
      </span>
      <span
        v-if="
          validation?.$error &&
          validation.maxValue &&
          validation.maxValue.$invalid
        "
        :id="`${id}-help`"
        class="p-error text-left mt-2"
      >
        {{ validation.maxValue.$message.replace("Value", PropName) }}
      </span>
    </div>
</template>

<script>
export default {
  props: {
    labelClass: {
      type: String,
      default: "form-label",
    },
    PropName: {
      type: String,
      default: "",
    },
    sectionClass: {
      type: String,
      default: "field",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    validation: {
      type: Object,
      required: false,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  computed: {
    modelValueComputed: {
      get() {
        return this.modelValue === null ? 0 : this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ui-input-number {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  height: 40px;
  resize: none;
  box-shadow: none;
  border-radius: 0.25rem;
  font-weight: 500;
  line-height: 1;
  font-family: "voyado Text";
  padding: 10px;
  /* Remove spinner arrows */
  -webkit-appearance: none;
  -moz-appearance: textfield;
  appearance: none;
}
.ui-input-number:disabled{
  background-color: #F0F0EF;
  opacity: 0.9;
}
.ui-input-number::-webkit-inner-spin-button,
.ui-input-number::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.ui-input-number:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
</style>